document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initVariantes();
  initAcordeon();
  initBarraFija();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;
  var principalImg = galeria.querySelector('[data-mt-galeria-principal] img');
  var miniaturas = galeria.querySelectorAll('[data-mt-galeria-mini]');
  miniaturas.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-full');
      if (!src || !principalImg) return;
      principalImg.setAttribute('src', src);
      miniaturas.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });
}

function initVariantes() {
  var forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector('[data-mt-add-btn]');
    var precioEl = form.querySelector('[data-mt-precio-actual]');
    var precioAnteriorEl = form.querySelector('[data-mt-precio-anterior]');
    var barraPrecio = document.querySelector('[data-mt-barra-precio]');
    var pillGroups = form.querySelectorAll('[data-mt-opcion]');

    function moneda(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format);
      }
      return (cents / 100).toFixed(2);
    }

    function seleccionActual() {
      var valores = [];
      pillGroups.forEach(function (group) {
        var activo = group.querySelector('.is-active');
        valores.push(activo ? activo.getAttribute('data-valor') : null);
      });
      return valores;
    }

    function actualizar() {
      var seleccion = seleccionActual();
      var match = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (precioEl) precioEl.textContent = moneda(match.price);
      if (barraPrecio) barraPrecio.textContent = moneda(match.price);
      if (precioAnteriorEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          precioAnteriorEl.textContent = moneda(match.compare_at_price);
          precioAnteriorEl.style.display = '';
        } else {
          precioAnteriorEl.style.display = 'none';
        }
      }
      if (addBtn) {
        if (match.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-label-add') || 'Añadir al carrito';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute('data-label-agotado') || 'Agotado';
        }
      }

      pillGroups.forEach(function (group, groupIndex) {
        group.querySelectorAll('button').forEach(function (btn) {
          var valor = btn.getAttribute('data-valor');
          var testSeleccion = seleccion.slice();
          testSeleccion[groupIndex] = valor;
          var existe = variantes.some(function (v) {
            return v.options.every(function (opt, i) { return opt === testSeleccion[i]; });
          });
          btn.disabled = !existe;
        });
      });
    }

    pillGroups.forEach(function (group) {
      group.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          group.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          actualizar();
        });
      });
    });

    actualizar();
  });
}

function initAcordeon() {
  var items = document.querySelectorAll('.mt-acordeon__item');
  items.forEach(function (item) {
    var btn = item.querySelector('.mt-acordeon__btn');
    var panel = item.querySelector('.mt-acordeon__panel');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var abierto = item.classList.contains('is-open');
      items.forEach(function (i) {
        i.classList.remove('is-open');
        var p = i.querySelector('.mt-acordeon__panel');
        if (p) p.style.maxHeight = null;
      });
      if (!abierto) {
        item.classList.add('is-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
}

function initBarraFija() {
  var barra = document.querySelector('[data-mt-barra-fija]');
  var trigger = document.querySelector('[data-mt-producto-form]');
  if (!barra || !trigger) return;
  var mostrar = false;
  window.addEventListener('scroll', function () {
    var rect = trigger.getBoundingClientRect();
    var deberia = rect.bottom < 0;
    if (deberia !== mostrar) {
      mostrar = deberia;
      barra.classList.toggle('is-visible', mostrar);
    }
  });
  var btnBarra = barra.querySelector('[data-mt-barra-add]');
  if (btnBarra) {
    btnBarra.addEventListener('click', function () {
      var addBtn = trigger.querySelector('[data-mt-add-btn]');
      if (addBtn) addBtn.click();
    });
  }
}
